import { render, staticRenderFns } from "./BogoTop.vue?vue&type=template&id=39707322&scoped=true&"
import script from "./BogoTop.vue?vue&type=script&lang=js&"
export * from "./BogoTop.vue?vue&type=script&lang=js&"
import style0 from "./BogoTop.vue?vue&type=style&index=0&id=39707322&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39707322",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow})
    

export default component.exports